import { createContext } from "react";
import {db,auth,analytics,storage} from "../firebase-public";



export const FirebaseContext = createContext({db,auth,analytics,storage});